import React from 'react';

import AiOpsChatIframeDrawer from './AiOpsChatIframeDrawer';

export function isAiChatDisabled(): boolean {
  return window.configs?.AI_CHAT_DISABLED === 'true';
}

export default function AiChatEntry() {
  if (isAiChatDisabled()) {
    return null;
  }

  return <AiOpsChatIframeDrawer />;
}
